import * as React from "react";
import { PT_ProtectiveFunction } from "../models/PT_ProtectiveFunction";
import { SFT_Targets } from "../models/SFT_Targets";
import Modal from "react-bootstrap/Modal";
import { DM_PT_DataSheet } from "../models/DM_PT_DataSheet";
import { ProtectiveFunction } from "../models/ProtectiveFunction";
import { DeviceData } from "../models/DeviceData";
import { ManualInputs } from "../models/ManualInputs";
import { ManualInput } from "../models/ManualInput";
import { SilModal } from "./SilModal";




interface Props {
  closeModal: () => void;
  device: DeviceData;
  manualInputs: ManualInputs;
  onManualInputsSave: (manualInputs: ManualInputs) => void;
  saveManualInputsFailed: (e: React.MouseEvent) => void;

    
}

interface State {
    secondDevice: boolean;
    closeFocus: boolean;
}

export class ManualInputModal extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            secondDevice: this.props.manualInputs.manualInput2 != null ? true : false,
            closeFocus: false
        }

    }

    private redundancy = React.createRef<HTMLSelectElement>();
    private deviceId1 = React.createRef<HTMLInputElement>();
    private deviceTag1 = React.createRef<HTMLInputElement>();
    private voting1 = React.createRef<HTMLInputElement>();
    private proofTestingInterval1 = React.createRef<HTMLInputElement>();
    private pfdavg1 = React.createRef<HTMLInputElement>();
    private str1 = React.createRef<HTMLInputElement>();
    private hft1 = React.createRef<HTMLSelectElement>();
    private deviceId2 = React.createRef<HTMLInputElement>();
    private deviceTag2 = React.createRef<HTMLInputElement>();
    private voting2 = React.createRef<HTMLInputElement>();
    private proofTestingInterval2 = React.createRef<HTMLInputElement>();
    private pfdavg2 = React.createRef<HTMLInputElement>();
    private str2 = React.createRef<HTMLInputElement>();
    private hft2 = React.createRef<HTMLSelectElement>();
           
    handleCheckBox = () => {
        if (this.state.secondDevice) {
            this.setState({
                secondDevice: false
            })
        }
        else if (this.state.secondDevice === false) {
            this.setState({
                secondDevice: true
            })
        }
        
    }

    handleClick = (e: React.MouseEvent) => {
        let manualInput1 = new ManualInput();
        
        const redundancyString = this.redundancy.current.value;
        var redundancy = false;
        if (redundancyString.trim() === "REN") {
            redundancy = true;
        }
        else if (redundancyString.trim() === "NREN") {
            redundancy = false;
        }

        const newDeviceId1 = this.deviceId1.current.value;
        const newDeviceTag1 = this.deviceTag1.current.value;
        const newVoting1 = this.voting1.current.value;
        const newProofTestingInterval1 = parseFloat(this.proofTestingInterval1.current.value);
        const newPfdAvg1 = parseFloat(this.pfdavg1.current.value);
        const newStr1 = parseFloat(this.str1.current.value);
        const newHft1 = parseFloat(this.hft1.current.value);
        
        manualInput1.deviceId = newDeviceId1;
        manualInput1.tagName = newDeviceTag1;
        manualInput1.voting = newVoting1;
        manualInput1.proofTestingInterval = newProofTestingInterval1;
        manualInput1.pfd = newPfdAvg1;
        manualInput1.stR1Year = newStr1;
        manualInput1.hft = newHft1;

        // If second manual device is enabled
        var newDeviceId2;
        var newDeviceTag2;
        var newVoting2;
        var newProofTestingInterval2;
        var newPfdAvg2;
        var newStr2;
        var newHft2;

        let manualInput2 = new ManualInput();
        if (this.state.secondDevice) {

            newDeviceId2 = this.deviceId2.current.value;
            newDeviceTag2 = this.deviceTag2.current.value;
            newVoting2 = this.voting2.current.value;
            newProofTestingInterval2 = parseFloat(this.proofTestingInterval2.current.value);
            newPfdAvg2 = parseFloat(this.pfdavg2.current.value);
            newStr2 = parseFloat(this.str2.current.value);
            newHft2 = parseFloat(this.hft2.current.value);

            manualInput2.deviceId = newDeviceId2;
            manualInput2.tagName = newDeviceTag2;
            manualInput2.voting = newVoting2;
            manualInput2.proofTestingInterval = newProofTestingInterval2;
            manualInput2.pfd = newPfdAvg2;
            manualInput2.stR1Year = newStr2;
            manualInput2.hft = newHft2;
        }

      // Make sure the number fields are actually numbers
      if ((isNaN(newProofTestingInterval1) && this.proofTestingInterval1.current.value !== '') || isNaN(newPfdAvg1) || isNaN(newStr1) || isNaN(newHft1)) {
        this.props.saveManualInputsFailed(e);
        return;
      }
        
      if (this.state.secondDevice) {
        if ((isNaN(newProofTestingInterval2) && this.proofTestingInterval2.current.value !== '')  || isNaN(newPfdAvg2) || isNaN(newStr2) || isNaN(newHft2)) {
          this.props.saveManualInputsFailed(e)
          return;
        }
      }

      if (this.state.secondDevice) {
        const manualInputs = new ManualInputs();
        manualInputs.manualInput1 = manualInput1;
        manualInputs.manualInput2 = manualInput2;
        manualInputs.isRedundant = redundancy;

        this.props.onManualInputsSave(manualInputs);
        this.props.closeModal();
      }
      else {
        const manualInputs = new ManualInputs();
        manualInputs.manualInput1 = manualInput1;
        manualInputs.isRedundant = redundancy;

        this.props.onManualInputsSave(manualInputs);
        this.props.closeModal();
      }
    }

    onMouseEnter = () => {
        this.setState({
            closeFocus: true
        })
    }

    onMouseLeave = () => {
        this.setState({
            closeFocus: false
        })
    }

    render() {


        return (
            <SilModal width={800} title="Manual Inputs" closeModal={this.props.closeModal}>
                
                    <div id="manualInputsDialog" className="dialog ui-dialog-content ui-widget-content" style={{ width: 'auto', display: 'block', minHeight: '0px', height: '475px' }} >
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-6">
                                <table>
                                    <tbody><tr>
                                        <td className="customerLogictable">
                                            <label>Redundancy</label>
                                        </td>
                                        <td className="customerlogictext">
                                                <select name="manualInputsRedundancy" id="manualInputsRedundancy" defaultValue={this.props.manualInputs.isRedundant ? "REN" : "NREN"} ref={this.redundancy}>
                                                <option value="REN">Redundant</option>
                                                <option value="NREN">Non-Redundant</option>
                                            </select>
                                        </td>
                                    </tr>
                                    </tbody></table>
                                <div className="well">
                                    <h4>Manual Input Device 1</h4>
                                    <table>
                                        <tbody><tr>
                                            <td className="customerLogictable">
                                                <span id="Label3">Device ID</span>
                                            </td>
                                            <td className="customerlogictext">
                                                    <input name="manualInputsDeviceId1" defaultValue={this.props.manualInputs.manualInput1.deviceId ? this.props.manualInputs.manualInput1.deviceId : ""} type="text" id="manualInputsDeviceId1" ref={this.deviceId1} />
                                            </td>
                                        </tr>
                                            <tr>
                                                <td className="customerLogictable">
                                                    <span id="Label41">Device Tag</span>
                                                </td>
                                                <td className="customerlogictext">
                                                        <input name="manualInputsTagName1" defaultValue={this.props.manualInputs.manualInput1.tagName ? this.props.manualInputs.manualInput1.tagName : ""} type="text" id="manualInputsTagName1" ref={this.deviceTag1} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="customerLogictable">
                                                    <span id="Label2">Voting</span>
                                                </td>
                                                <td className="customerlogictext">
                                                        <input name="manualInputsVoting1" defaultValue={this.props.manualInputs.manualInput1.voting ? this.props.manualInputs.manualInput1.voting : ""} type="text" id="manualInputsVoting1" ref={this.voting1} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="customerLogictable">
                                                    <span id="Label8">TI (Yr)</span>
                                                </td>
                                                <td className="customerlogictext">
                                                        <input name="manualInputsTI1" defaultValue={this.props.manualInputs.manualInput1.proofTestingInterval ? this.props.manualInputs.manualInput1.proofTestingInterval.toString() : ""} type="text" id="manualInputsTI1" ref={this.proofTestingInterval1} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="customerLogictable">
                                                    <span id="Label15">PFDavg</span>
                                                </td>
                                                <td className="customerlogictext">
                                                    <input name="manualInputsPFD1" defaultValue={this.props.manualInputs.manualInput1.pfd ? this.props.manualInputs.manualInput1.pfd.toString() : "0"} type="text" id="manualInputsPFD1" ref={this.pfdavg1}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="customerLogictable">
                                                    <span id="Label25">STR (1/Yr)</span>
                                                </td>
                                                <td className="customerlogictext">
                                                        <input name="manualInputsSTR1Year1" defaultValue={this.props.manualInputs.manualInput1.stR1Year ? this.props.manualInputs.manualInput1.stR1Year.toString() : "0"} type="text" id="manualInputsSTR1Year1" ref={this.str1}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="customerLogictable">
                                                    <span id="Label26">HFT</span>
                                                </td>
                                                <td className="customerlogictext">
                                                        <select name="manualInputsHFT1" defaultValue={this.props.manualInputs.manualInput1.hft ? this.props.manualInputs.manualInput1.hft : 0} id="manualInputsHFT1" ref={this.hft1}>
                                                        <option value={0}>0</option>
                                                        <option value={1}>1</option>
                                                        <option value={2}>2</option>
                                                    </select>
                                                </td>
                                            </tr>
                                        </tbody></table>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <table>
                                    <tbody><tr>
                                        <td className="customerLogictable" colSpan={2}>
                                                <input id="enableSecondManualInput" type="checkbox" name="enableSecondManualInput" checked={this.state.secondDevice ? true : false} onChange={this.handleCheckBox}/><label htmlFor="enableSecondManualInput">Enable second manual input device</label>
                                        </td>
                                    </tr>
                                    </tbody></table>
                                <div className="well">
                                    <h4>Manual Input Device 2</h4>
                                    <table>
                                        <tbody><tr>
                                            <td className="customerLogictable">
                                                <span id="Label10">Device ID</span>
                                            </td>
                                            <td className="customerlogictext">
                                                    <input name="manualInputsDeviceId2" type="text" id="manualInputsDeviceId2" defaultValue={(this.props.manualInputs.manualInput2 != null && this.props.manualInputs.manualInput2.deviceId) ? this.props.manualInputs.manualInput2.deviceId : ""} style={{ backgroundColor: !this.state.secondDevice ? "lightgray" : "white" }} disabled={!this.state.secondDevice ? true : false} ref={this.deviceId2} />
                                            </td>
                                        </tr>
                                            <tr>
                                                <td className="customerLogictable">
                                                    <span id="Label42">Device Tag</span>
                                                </td>
                                                <td className="customerlogictext">
                                                        <input name="manualInputsTagName2" type="text" id="manualInputsTagName2" defaultValue={(this.props.manualInputs.manualInput2 != null && this.props.manualInputs.manualInput2.tagName) ? this.props.manualInputs.manualInput2.tagName : ""}style={{ backgroundColor: !this.state.secondDevice ? "lightgray" : "white" }} disabled={!this.state.secondDevice ? true : false} ref={this.deviceTag2} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="customerLogictable">
                                                    <span id="Label27">Voting</span>
                                                </td>
                                                <td className="customerlogictext">
                                                        <input name="manualInputsVoting2" type="text" id="manualInputsVoting2" defaultValue={(this.props.manualInputs.manualInput2 != null && this.props.manualInputs.manualInput2.voting) ? this.props.manualInputs.manualInput2.voting : ""} style={{ backgroundColor: !this.state.secondDevice ? "lightgray" : "white" }} disabled={!this.state.secondDevice ? true : false} ref={this.voting2}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="customerLogictable">
                                                    <span id="Label34">TI (Yr)</span>
                                                </td>
                                                <td className="customerlogictext">
                                                        <input name="manualInputsTI2" type="text" id="manualInputsTI2" defaultValue={(this.props.manualInputs.manualInput2 != null && this.props.manualInputs.manualInput2.proofTestingInterval) ? this.props.manualInputs.manualInput2.proofTestingInterval.toString() : ""} style={{ backgroundColor: !this.state.secondDevice ? "lightgray" : "white" }} disabled={!this.state.secondDevice ? true : false} ref={this.proofTestingInterval2} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="customerLogictable">
                                                    <span id="Label35">PFDavg</span>
                                                </td>
                                                <td className="customerlogictext">
                                                        <input name="manualInputsPFD2" type="text" id="manualInputsPFD2" defaultValue={(this.props.manualInputs.manualInput2 != null && this.props.manualInputs.manualInput2.pfd) ? this.props.manualInputs.manualInput2.pfd.toString() : "0"} style={{ backgroundColor: !this.state.secondDevice ? "lightgray" : "white" }} disabled={!this.state.secondDevice ? true : false} ref={this.pfdavg2} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="customerLogictable">
                                                    <span id="Label36">STR (1/Yr)</span>
                                                </td>
                                                <td className="customerlogictext">
                                                        <input name="manualInputsSTR1Year2" type="text" id="manualInputsSTR1Year2" defaultValue={(this.props.manualInputs.manualInput2 != null && this.props.manualInputs.manualInput2.stR1Year) ? this.props.manualInputs.manualInput2.stR1Year : "0"} style={{ backgroundColor: !this.state.secondDevice ? "lightgray" : "white" }} disabled={!this.state.secondDevice ? true : false} ref={this.str2} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="customerLogictable">
                                                    <span id="Label40">HFT</span>
                                                </td>
                                                <td className="customerlogictext">
                                                        <select name="manualInputsHFT2" id="manualInputsHFT2" defaultValue={(this.props.manualInputs.manualInput2 != null && this.props.manualInputs.manualInput2.hft) ? this.props.manualInputs.manualInput2.hft : 0} style={{ backgroundColor: !this.state.secondDevice ? "lightgray" : "white" }} disabled={!this.state.secondDevice ? true : false} ref={this.hft2}>
                                                        <option value={0}>0</option>
                                                        <option value={1}>1</option>
                                                        <option value={2}>2</option>
                                                    </select>
                                                </td>
                                            </tr>
                                        </tbody></table>
                                </div>
                            </div>
                        </div>
                        <div style={{ textAlign:"left"}}>
                                <input type="submit" name="manualInputSave" defaultValue="Update" id="manualInputSave" className="green-button edit-button" onClick={(e:React.MouseEvent) => this.handleClick(e)}/>
                        </div>
                    </div>
                </div>
            </SilModal>
        );
    }
}